// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".seachTiele[data-v-6ce5c7ce] {\n  line-height: 35px;\n}\n.fr[data-v-6ce5c7ce] {\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
